function Projects() {
    const projects = [
        {
            id: 1,
            title: 'Stock Volatility Forecasting Dashboard',
            description: 'Dashboard for stock analysis, forecasting stock volatility and forecasting stock prices using OLS regression, ARIMA, and GARCH modeling. Made with python, streamlit, yfinance.',
            image: '/images/project1.png',
            tags: ['Python', 'Streamlit', 'Pandas', 'Streamlit'],
            demoUrl: null, // Add your Cloudflare URL later
            githubUrl: 'https://github.com/charles-cetta/Stock_Volatility_Dashboard'
        },
        {
            id: 2,
            title: 'WalletWise Finance Tracking Dashboard',
            description: 'Full-Stack Finance and Budgeting Web Application, providing an analysis of bank statement data using React, python, and custom ML models',
            image: 'public/images/WalletWise.jpeg',
            tags: ['React', 'MongoDB', 'API', 'Python'],
            demoUrl: null,
            githubUrl: 'https://github.com/charles-cetta/WalletWise'
        },
        {
            id: 3,
            title: 'Credit Risk Model',
            description: 'Classification model to assess loan default probability using ensemble methods and feature engineering.',
            image: '/images/project3.png',
            tags: ['Python', 'Scikit-learn', 'SQL'],
            demoUrl: null,
            githubUrl: 'https://github.com/yourusername/project3'
        },
        {
            id: 4,
            title: 'Find Your Vote NJ',
            description: 'An interactive web application that helps New Jersey residents find information about their congressional districts, representatives, and upcoming elections. Using Azure SQL and React.',
            image: '/assets/1740169217975.jpeg',
            tags: ['React', 'Javascript', 'Azure SQL'],
            demoUrl: null,
            githubUrl: 'https://github.com/charles-cetta/findyourvote-nj'
        }
    ];

    return (
        <main style={{ maxWidth: '1000px', margin: '0 auto', padding: '4rem 2rem' }}>
            <h1>Projects</h1>
            <p style={{ color: '#555', marginBottom: '2rem' }}>
                A selection of my data science and development work
            </p>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '2rem'
            }}>
                {projects.map((project) => (
                    <div
                        key={project.id}
                        style={{
                            backgroundColor: '#FEFDFB',
                            border: '1px solid #E8DDD0',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            cursor: 'pointer'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-4px)';
                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(184, 87, 78, 0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                        <img
                            src={project.image}
                            alt={project.title}
                            style={{
                                width: '100%',
                                height: '180px',
                                objectFit: 'cover',
                                backgroundColor: '#FFF5EB'
                            }}
                        />
                        <div style={{ padding: '1.25rem' }}>
                            <h3 style={{ margin: '0 0 0.5rem 0' }}>{project.title}</h3>
                            <p style={{ color: '#666', fontSize: '0.9rem', lineHeight: '1.5' }}>
                                {project.description}
                            </p>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '1rem' }}>
                                {project.tags.map((tag) => (
                                    <span
                                        key={tag}
                                        style={{
                                            backgroundColor: '#FFF5EB',
                                            padding: '0.25rem 0.75rem',
                                            borderRadius: '50px',
                                            fontSize: '0.8rem',
                                            color: '#A0522D',
                                            border: '1px solid #E8DDD0'
                                        }}
                                    >
                    {tag}
                  </span>
                                ))}
                            </div>

                            <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                                {project.demoUrl && (
                                    <a
                                        href={project.demoUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#A0522D', fontSize: '0.9rem' }}
                                    >
                                        Live Demo →
                                    </a>
                                )}
                                {project.githubUrl && (
                                    <a
                                        href={project.githubUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: '#8B4513', fontSize: '0.9rem' }}
                                    >
                                        GitHub
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </main>
    );
}

export default Projects;


